import { numberWithCommas } from "pages/BillingPortal/utils";
import { Card, Colors, fontSmall } from "swing-components";

import { translate } from "~utils";

type SchoolInsightItem = {
  filledReqs: number;
  daysCovered: number;
  spedFillRate: number;
  spedTotal: number;
  spedFilled: number;
  totalReqs: number;
  spend: number;
  schoolName: string;
  lmTotal: number;
  lmFillRate: number;
  lmFilled: number;
  fillRate: number;
};

export type DistrictInsightItem = {
  districtName: string;
  spend: number;
  daysCovered: number;
  overallFillRate: number;
  spedFillRate: number;
  lmFillRate: number;
  schools: Array<SchoolInsightItem>;
};

type DistrictInsightSectionProps = {
  district: DistrictInsightItem;
};

export function DistrictInsightSection(props: DistrictInsightSectionProps) {
  const { district } = props;

  const InsightItemCSS = {
    borderTop: "solid 1px var(--swing-slate200)",
    padding: "24px 0",
  };

  const InsightRowCSS = {
    padding: "8px 24px",
    display: "grid",
    alignItems: "center",
    gridTemplateColumns: "134px repeat(4, 138px)",
    gap: 27,
    borderBottom: `solid 2px ${Colors.slate200}`,
    minHeight: 64,
    p: {
      margin: 0,
    },
  };

  return (
    <div>
      {/* Total Spend, Days Covered */}
      <div css={InsightItemCSS}>
        <h3 css={{ margin: 0 }}>{district.districtName}</h3>
        <div css={{ marginTop: 24, display: "flex", gap: 16 }}>
          <Card borderColor="var(--swing-slate200)">
            <p css={{ margin: 0, fontWeight: 600 }}>{translate("INSIGHTS_TOTAL_SPEND")}</p>
            <h1 css={{ margin: 0 }}>${numberWithCommas(district.spend)}</h1>
          </Card>
          {/* <Card borderColor="var(--swing-slate200)"> */}
          {/*   <p css={{ margin: 0, fontWeight: 600 }}>{translate("INSIGHTS_DAYS_COVERED")}</p> */}
          {/*   <h1 css={{ margin: 0 }}>{district.daysCovered}</h1> */}
          {/* </Card> */}
        </div>
      </div>

      {/* Fill Rate */}
      <div css={InsightItemCSS}>
        <h3 css={{ margin: 0 }}>{translate("INSIGHTS_FILL_RATE_HEADER")}</h3>
        {/* Overall */}
        <div css={{ marginTop: 24, display: "flex", gap: 16 }}>
          <Card borderColor="var(--swing-slate200)">
            <p css={{ margin: 0, fontWeight: 600 }}>{translate("INSIGHTS_OVERALL")}</p>
            <h1 css={{ margin: 0 }}>{district.overallFillRate.toFixed(0)}%</h1>
          </Card>
          {/* Special Education */}
          <Card borderColor="var(--swing-slate200)">
            <p css={{ margin: 0, fontWeight: 600 }}>{translate("INSIGHTS_SPED")}</p>
            <h1 css={{ margin: 0 }}>
              {district.spedFillRate > 0
                ? `${district.spedFillRate.toFixed(0)}%`
                : translate("INSIGHTS_NA")}
            </h1>
          </Card>
          {/* Last minute */}
          <Card borderColor="var(--swing-slate200)">
            <p css={{ margin: 0, fontWeight: 600 }}>{translate("INSIGHTS_LM")}</p>
            <h1 css={{ margin: 0 }}>
              {district.lmFillRate > 0
                ? `${district.lmFillRate.toFixed(0)}%`
                : translate("INSIGHTS_NA")}
            </h1>
          </Card>
        </div>
      </div>
      {/* Site Breakdown */}
      <div css={InsightItemCSS}>
        <h3 css={{ margin: 0 }}>{translate("INSIGHTS_SITE_BREAKDOWN_HEADER")}</h3>
        <div
          css={{
            maxWidth: 900,
            margin: "16px 0",
            overflowX: "scroll",
            background: "white",
            borderRadius: 8,
            border: `solid 1px ${Colors.slate200}`,
          }}
        >
          <div css={InsightRowCSS}>
            <span css={{ fontWeight: 600 }}>{translate("INSIGHTS_SITE")}</span>
            <div>
              <p css={{ fontWeight: 600 }}>{translate("INSIGHTS_SPEND")}</p>
              <p css={{ ...fontSmall() }}>{translate("INSIGHTS_SY_TO_DATE")}</p>
            </div>
            {/* <div> */}
            {/*   <p css={{ fontWeight: 600 }}>{translate("INSIGHTS_DAYS")}</p> */}
            {/*   <p css={{ ...fontSmall() }}>{translate("INSIGHTS_COVERED")}</p> */}
            {/* </div> */}
            <div>
              <p css={{ fontWeight: 600 }}>{translate("INSIGHTS_OVERALL")}</p>
              <p css={{ ...fontSmall() }}>{translate("INSIGHTS_FR")}</p>
            </div>
            <div>
              <p css={{ fontWeight: 600 }}>{translate("INSIGHTS_SPED_SHORT")}</p>
              <p css={{ ...fontSmall() }}>{translate("INSIGHTS_FR")}</p>
            </div>
            <div>
              <p css={{ fontWeight: 600 }}>{translate("INSIGHTS_LM_SHORT")}</p>
              <p css={{ ...fontSmall() }}>{translate("INSIGHTS_FR")}</p>
            </div>
          </div>
          {district.schools.map((school, idx) => {
            return (
              <div key={idx} css={InsightRowCSS}>
                <div>{school.schoolName}</div>
                <div>${numberWithCommas(school.spend)}</div>
                {/* <div>{school.daysCovered}</div> */}
                <div>{school.fillRate.toFixed(0)}%</div>
                <div>{school.spedFillRate.toFixed(0)}%</div>
                <div>{school.lmFillRate.toFixed(0)}%</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
